import axios from 'axios';

export default {
  getInfoByLatLng: (latLng) => {
    let url = `https://maps.googleapis.com/maps/api/geocode/json?latlng={0}&sensor=true&key=${process.env.RAZZLE_GOOGLE_MAPS_API_KEY}`;
    url = url.replace(/\{0\}/g, latLng);

    return axios
      .get(url)
      .then((response) => {
        return response;
      })
      .catch(() => {
        return 'invalid request';
      });
  },
};
